import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendExternalSignupInvite,
  BackendQueryExternalSignupDetailsArgs,
} from 'src/types/backend';

const QUERY = gql`
  query ExternalSignupDetails($token: String!) {
    externalSignupDetails(token: $token) {
      email
    }
  }
`;

type Variables = BackendQueryExternalSignupDetailsArgs;
type Result = BackendExternalSignupInvite;

export const externalSignupDetails = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
